const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 60,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 80,
	},
	{
		prop: "HPName",
		label: "医院名称",
		columnwidth: 150,
	},
	{
		prop: "TechnicalOfficesName",
		label: "科室",
		columnwidth: 120,
	},
	{
		prop: "HPCode",
		label: "医院编码",
		columnwidth: 80,
	},
	{
		prop: "ProvinceName",
		label: "省份",
		columnwidth: 80,
	},
	{
		prop: "CityName",
		label: "城市",
		columnwidth: 80,
	},
	{
		prop: "HosGrade",
		label: "医院级别",
		columnwidth: 80,
	},
	{
		prop: "CountryMan",
		label: "全国总监",
		columnwidth: 80,
	},
	{
		prop: "RegionMan",
		label: "大区经理",
		columnwidth: 130,
	},
	{
		prop: "AreaMan",
		label: "地区经理",
		columnwidth: 170,
	},
	{
		prop: "SalesMan",
		label: "销售代表",
		columnwidth: 150,
	},
	{
		prop: "LEVEL3",
		label: "Level3",
		columnwidth: 140,
	},
	{
		prop: "MoneyQuota",
		label: "年度金额BP",
		columnwidth: 100,
	},
	{
		prop: "QuantityQuota",
		label: "年度数量BP",
		columnwidth: 100,
	},
	{
		prop: "JanMoneyQuota",
		label: "一月金额指标",
		columnwidth: 120,
	},
	{
		prop: "FebMoneyQuota",
		label: "二月金额指标",
		columnwidth: 120,
	},
	{
		prop: "MarMoneyQuota",
		label: "三月金额指标",
		columnwidth: 120,
	},
	{
		prop: "AprMoneyQuota",
		label: "四月金额指标",
		columnwidth: 120,
	},
	{
		prop: "MayMoneyQuota",
		label: "五月金额指标",
		columnwidth: 120,
	},
	{
		prop: "JunMoneyQuota",
		label: "六月金额指标",
		columnwidth: 120,
	},
	{
		prop: "JulMoneyQuota",
		label: "七月金额指标",
		columnwidth: 120,
	},
	{
		prop: "AugMoneyQuota",
		label: "八月金额指标",
		columnwidth: 120,
	},
	{
		prop: "SepMoneyQuota",
		label: "九月金额指标",
		columnwidth: 120,
	},
	{
		prop: "OctMoneyQuota",
		label: "十月金额指标",
		columnwidth: 120,
	},
	{
		prop: "NovMoneyQuota",
		label: "十一月金额指标",
		columnwidth: 120,
	},
	{
		prop: "DecMoneyQuota",
		label: "十二月金额指标",
		columnwidth: 120,
	},
	{
		prop: "JanQuantityQuota",
		label: "一月数量指标",
		columnwidth: 120,
	},
	{
		prop: "FebQuantityQuota",
		label: "二月数量指标",
		columnwidth: 120,
	},
	{
		prop: "MarQuantityQuota",
		label: "三月数量指标",
		columnwidth: 120,
	},
	{
		prop: "AprQuantityQuota",
		label: "四月数量指标",
		columnwidth: 120,
	},
	{
		prop: "MayQuantityQuota",
		label: "五月数量指标",
		columnwidth: 120,
	},
	{
		prop: "JunQuantityQuota",
		label: "六月数量指标",
		columnwidth: 120,
	},
	{
		prop: "JulQuantityQuota",
		label: "七月数量指标",
		columnwidth: 120,
	},
	{
		prop: "AugQuantityQuota",
		label: "八月数量指标",
		columnwidth: 120,
	},
	{
		prop: "SepQuantityQuota",
		label: "九月数量指标",
		columnwidth: 120,
	},
	{
		prop: "OctQuantityQuota",
		label: "十月数量指标",
		columnwidth: 120,
	},
	{
		prop: "NovQuantityQuota",
		label: "十一月数量指标",
		columnwidth: 120,
	},
	{
		prop: "DecQuantityQuota",
		label: "十二月数量指标",
		columnwidth: 120,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 130,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 130,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 130,
	}
];
export default headerData;
